export default "<p>produit-detail-modal works!</p>\r\n";